export default "/fonts/Poppins-ExtraLight.ttf?811983a93d6817529003ffa15205e4d2";